import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getIsLoggedInSelector, getHasAuthLoadedSelector } from '@americanexpress/travel-selectors';
import browserCookies from 'browser-cookies';
import { addLazyLoadTealeafIdToErrorReporting } from '../../thunks/tealeafThunks';

export const CookieHandlerComponent = ({ isLoggedIn, hasAuthLoaded }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(addLazyLoadTealeafIdToErrorReporting);
  }, [dispatch]);

  React.useEffect(() => {
    if (global.BROWSER && !isLoggedIn && hasAuthLoaded) {
      if (browserCookies.get('tls_smra')) {
        browserCookies.erase('tls_smra', {
          path: '/',
          domain: '.americanexpress.com',
        });
      }
    }
  }, [hasAuthLoaded, isLoggedIn]);
  return null;
};

CookieHandlerComponent.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  hasAuthLoaded: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  hasAuthLoaded: getHasAuthLoadedSelector,
});

export default connect(mapStateToProps)(CookieHandlerComponent);
